export default __webpack_public_path__ + "static/media/mall-banner-vn.b46f4f5b.webp";